import { render, staticRenderFns } from "./comment-index.vue?vue&type=template&id=eb6a594e"
import script from "./comment-index.vue?vue&type=script&lang=js"
export * from "./comment-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports